import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-preparation-item-comment-dialog.controller';
import template from './edit-preparation-item-comment-dialog.html';
import validator, { name as validatorName } from '../messages/preparation-item.unique-name.validator.directive';
import nameMessageTpl from '../messages/preparation-item.name.messages.html';

class dialogService {
  getOptions($event, { preparationItemId, preparationItemCommentId, preparationItemCommentText }) {
    return {
      controller,
      controllerAs: 'editPreparationItemCommentDialogVM',
      locals: {
        preparationItemId,
        preparationItemCommentId,
        preparationItemCommentText
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editPreparationItemCommentDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('editPreparationItemCommentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('preparation-item.name.messages.html', nameMessageTpl);
  })
  .name;
